const route = [
  {
    path: '/info-footer/:type',
    name: 'info-footer',
    component: () => import('@/views/johnnsInfo/statement'),
  },
  {
    path: '/info-root/:type',
    name: 'info-root',
    component: () => import('@/views/johnnsInfo/root/index'),
  },
];

export default route;
